import styled from 'styled-components';

import bg from '~/assets/bg-section-03.png';
import vetor from '~/assets/ilustra-02.png';

export const Container = styled.section`
  margin: 0 0 125px;
  padding: 180px 0px 105px;
  overflow: hidden;
  position: relative;
  .ArrowDown {
    margin-bottom: 40px;
  }
`;

export const Title = styled.h3`
  width: 100%;
  max-width: 1710px;
  padding: 0 15px;
  color: #27357c;
  font-size: 50px;
  font-weight: 900;
  text-shadow: 2px 2px 0 white;
  text-align: right;
  span {
    color: #831d13;
  }
  @media (max-width: 992px) {
    font-size: calc(100vw / 15);
  }
  @media (max-width: 540px) {
    font-size: calc(100vw / 10);
  }
  @media (max-width: 480px) {
    font-size: 40px;
  }
`;

export const Content = styled.div`
  position: relative;
  background-color: rgba(239, 133, 52, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* align-items: center; */
  margin-top: 35px;
  &:before,
  &:after {
    content: '';
    display: block;
    width: 100%;
    position: absolute;
    left: 0;
    background-repeat: no-repeat;
    background-image: url(${bg});
  }
  &:before {
    height: 75px;
    background-position: top center;
    top: 0;
    margin-top: -75px;
  }
  &:after {
    height: 115px;
    background-position: bottom center;
    background-size: 120%;
    bottom: 0;
    margin-bottom: -115px;
  }
`;

export const ContentLineTitle = styled.div`
  padding: 45px 45px 5px;
  h3 {
    color: #27357c;
    font-size: 35px;
    font-weight: 900;
    text-shadow: 2px 2px 0 white;
    border-bottom: solid 3px #27357c;
    padding-bottom: 15px;
    span {
      color: #831d13;
    }
    & > p {
      padding-top: 15px;
      font-size: 16px;
      color: #333;
      text-shadow: none;
      font-weight: 400;
      span {
        font-weight: 900;
      }
    }
  }
`;
export const Vector = styled.div`
  /* flex: 0 0 50%; */
  flex: 0 0 27.6%;
  /* max-width: 50%; */
  max-width: 525px;
  min-height: 850px;
  /* height: 100%; */
  background-image: url(${vetor});
  background-repeat: no-repeat;
  background-position: bottom right;
  background-size: 185%;
  transform: translateY(45px);
  z-index: 3;
  @media (max-width: 1366px) {
    min-height: auto;
  }
  @media (max-width: 992px) {
    position: absolute;
    min-height: auto;
    width: 50%;
    height: 100%;
    background-size: contain;
    background-position: left -200px bottom;
    z-index: 10;
  }
  @media (max-width: 660px) {
    background-position: left bottom;
  }
`;
export const SliderContainer = styled.div`
  flex-grow: 1;
  width: 100%;
  /* width: 72.4%; */
  /* padding-left: 70px; */
  /* overflow: hidden; */
  /* @media (max-width: 992px) { */
  @media (max-width: 1200px) {
    width: 100%;
    padding: 0 20px;
    z-index: 11;
  }
`;
